var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    rx: 4,
    fill: "#F5F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60048 10.7002C5.36203 10.7002 5.23176 10.4221 5.38442 10.2389L9.28394 5.55947C9.39638 5.42454 9.60362 5.42454 9.71606 5.55947L13.6156 10.2389C13.7682 10.4221 13.638 10.7002 13.3995 10.7002L5.60048 10.7002Z",
    fill: "#414143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinArrow);
export default __webpack_public_path__ + "static/media/spin-arrow.c42ae303bb469cbc8b14e4f5c853d725.svg";
export { ForwardRef as ReactComponent };